/**
 * Days of week in ISO 8601 format.
 * Monday is 1, Sunday is 7.
 * @see https://en.wikipedia.org/wiki/ISO_week_date
 */
export const DAYS_OF_WEEK = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7,
};

/** The `code` the availability route sends when Google permanently refuses the provider's calendar. */
export const AVAILABILITY_ERROR_CODES = {
  CALENDAR_REFUSED: 'availability_calendar_refused',
} as const;
